export class TotalServicios {
    constructor(
        public totalMinUF: number,
        public totalMaxUF: number,
        public totalMinCLP: number,
        public totalMaxCLP: number
    ) {
        this.totalMinUF = totalMinUF;
        this.totalMaxUF = totalMaxUF;
        this.totalMinCLP = totalMinCLP;
        this.totalMaxCLP = totalMaxCLP;
    }
}
